import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { authAtom, userAtom, roleAtom } from './core/config/atoms';

import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import { jwtDecode } from "jwt-decode";

import PageAuth from './pages/PageAuth';
import PageHome from './pages/PageHome';
import Page404 from './pages/Page404';

import ServiceAuth from 'services/serviceAuth';
import ServiceUtil from 'services/serviceUtil';

export default function App() {

    const [authStatus, setAuthStatus] = useRecoilState(authAtom);
    const [, setUserData] = useRecoilState(userAtom);
    const [, setUserRole] = useRecoilState(roleAtom);

    const authService = new ServiceAuth();
    const utilService = new ServiceUtil();

    const decryptData = (encryptedData, iv) => {
        const keyWA = CryptoJS.enc.Hex.parse("b71c2e3ab56ff1a934a819e92618f26d02c7388a4e604d5b0c2c946e8d640c23");
        const ivWA = CryptoJS.enc.Base64.parse(iv);

        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(encryptedData)
        });

        const plain = CryptoJS.AES.decrypt(cipherParams, keyWA, { iv: ivWA });
        const decrypted = plain.toString(CryptoJS.enc.Utf8);
        return decrypted;
    }

    const checkUser = () => {
        setUserData(utilService.getDecrypted("user"));
        setUserRole(utilService.getDecrypted("roles"));
        authService.staffRefresh().then((res) => {
            if (res.status) {
                const decoded = jwtDecode(res.data.token);
                const roles = decryptData(decoded.encrypted, decoded.iv);
                setUserData(res.data.user);
                setUserRole(JSON.parse(roles));
                utilService.saveEncrypted("user", res.data.user);
                utilService.saveEncrypted("roles", JSON.parse(roles));
            } else {
                setAuthStatus(false);
                setUserData({});
                setUserRole({});
                localStorage.clear();
                sessionStorage.clear();
                window.location.replace('/');
                toast.error('Error: ' + res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        }).catch((res) => {
            console.log("Here");
        });
    }

    useEffect(() => {
        if (authStatus) {
            checkUser();
        }
    }, [authStatus]);

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} rtl={false} theme="light" />
            <Router>
                <Routes>
                    <Route exact path="/" element={<PageAuth />} />
                    {authStatus && <Route exact path="/:page/*" element={<PageHome />} />}
                    {authStatus && <Route exact path="/:page/:id" element={<PageHome />} />}
                    {authStatus && <Route exact path="/:page/:org/:id" element={<PageHome />} />}
                    <Route path="*" element={<Page404 />} />
                </Routes>
            </Router>
        </>
    )
}